import script from "./RoomView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomView.vue?vue&type=script&setup=true&lang=ts"

import "./RoomView.vue?vue&type=style&index=0&id=6e7de2d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e7de2d7"]])

export default __exports__